#import "../fragments/account-summary-fragment.graphql"

mutation UpdateAccountSummary($input: AccountUpdateInput!) {
    accountUpdate(input: $input) {
        account {
            ...AccountSummaryFragment
        }
    }
}
